import { Component } from 'js-component-framework';

/**
 * Component for site header and drawer.
 */
export default class SearchInput extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.toggleClear();
  }

  toggleClear() { // eslint-disable-line

    const {
      searchInput,
      searchClear,
    } = this.children;

    if (! searchInput || ! searchClear) {
      return;
    }

    searchInput.addEventListener('input', () => {
      if ('' !== searchInput.value) {
        searchClear.classList.add('is-visible');
      } else {
        searchClear.classList.remove('is-visible');
      }
    });

    searchClear.addEventListener('click', () => {
      searchInput.value = '';
      searchClear.classList.remove('is-visible');
    });
  }
}
